<template>
  <div
    class="
      tw-grow tw-shrink-0 tw-basis-full
      xl:tw-basis-[40%]
      2xl:tw-basis-[30%]
      tw-max-w-full tw-font-sans tw-rounded-lg tw-p-4 tw-bg-sf-neutral-subtle-1
    "
    data-testid="ai-ocr-upload-section"
  >
    <div>
      <div class="tw-inline-flex tw-items-center tw-gap-2 tw-mb-4">
        <span class="tw-text-sm tw-text-sf-gray-darker tw-font-medium">{{
          sectionName
        }}</span>
        <span
          class="
            tw-px-2 tw-py-1 tw-bg-sf-primary-subtle tw-text-sf-primary-darker
            icon
            sf-pointer
            icon-paperclip
            tw-rounded-full
          "
          data-testid="ai-ocr-upload-document-button"
          @click="handleUploadClick"
        ></span>
      </div>

      <div
        v-if="doesSectionHaveDocuments"
        class="tw-flex tw-flex-wrap tw-gap-2"
      >
        <DocumentPill
          v-for="doc in sectionDocuments"
          :key="doc.id"
          :document="doc"
          @import-document:delete="handleDocumentDelete"
        />
      </div>
      <div v-else class="tw-text-sm tw-text-sf-gray-darker">
        {{ I18n.t('ai_ocr_documents.banner.section.empty') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import DocumentPill from './document-pill.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import { useOCRDocuments } from '../store/use-ocr-documents'
import { useOCRSections } from '../store/use-ocr-sections'

interface Props {
  section: string
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    delete: [documentId: number | string]
    upload: [section: string]
  }>()

const I18n = useI18n()

const documentStore = useOCRDocuments()
const sectionStore = useOCRSections()

const { documents } = storeToRefs(documentStore)
const { sections, sectionNames } = storeToRefs(sectionStore)

const doesSectionHaveDocuments = computed(() => {
  return sectionDocuments.value.length > 0
})

const sectionName = computed(() => {
  return sectionNames.value[props.section]
})

const sectionDocuments = computed(() => {
  const sectionDocumentIds = sections.value[props.section]

  return sectionDocumentIds.map((id) => documents.value[id]).filter(Boolean)
})

function handleDocumentDelete(id: number | string) {
  emit('delete', id)
}

function handleUploadClick() {
  emit('upload', props.section)
}
</script>
